var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212B36;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.1,9.3c-0.2-0.4-0.6-0.7-1-1C26.8,8.1,26.3,8,25.8,8H8.8L8,5C7.9,4.7,7.7,4.4,7.5,4.3C7.3,4.1,7,4,6.7,4H4 C3.6,4,3.3,4.1,3.1,4.4C2.8,4.6,2.7,5,2.7,5.3c0,0.4,0.1,0.7,0.4,0.9C3.3,6.5,3.6,6.7,4,6.7h1.7l3.7,13.7c0.1,0.3,0.3,0.5,0.5,0.7 c0.2,0.2,0.5,0.3,0.8,0.3h12c0.2,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.5l4.4-8.7c0.2-0.4,0.3-0.8,0.3-1.3 C28.5,10.1,28.3,9.7,28.1,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,28c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C8,27.1,8.9,28,10,28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,28c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2C21.3,27.1,22.2,28,23.3,28z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseProduct);
export default __webpack_public_path__ + "static/media/purchase_product.b1f224dfe0b61004ae9b4a5249c36326.svg";
export { ForwardRef as ReactComponent };